import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n"])));
export var TextCenter = function TextCenter(props) {
  var children = props.children;
  return /*#__PURE__*/_jsx(Container, {
    children: children
  });
};
export default TextCenter;